// Global Components
import React, { useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

// Platform Specific
import Home from '../home/home';
import Root from '../root/root';
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  RedirectFunction,
  redirect,
} from 'react-router-dom';

// Shared Libraries
import { PageNotFound } from '@breakroom-nx/ui';
import {
  useAppDispatch,
  login,
  openModal,
  setCurrentUserUID,
  useLazyGetCurrentUserQuery,
} from '@breakroom-nx/redux';
import { Status } from '@breakroom-nx/helpers';

function RequireAuth({ children }: { children: JSX.Element }) {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [trigger, { data: currentUser, isLoading }] =
    useLazyGetCurrentUserQuery();
  const auth = getAuth();

  // console.log(
  //   `[Auth Navigator] Authentication Required for Page: ${location.pathname}`
  // );

  useEffect(() => {
    // console.log(`Auth Navigator Triggered`);
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      // console.log(`Auth State Changed`);
      if (!user) {
        // console.log(
        //   '[Auth Navigator] No User Found -> Navigating to Welcome Page'
        // );
        dispatch(
          openModal({
            modalType: 'Alert',
            modalProps: {
              status: Status.warning,
              title: 'You have to be logged in to view that page.',
            },
          })
        );
        navigate('/', {
          state: { from: location },
          replace: true,
        });
      } else {
        // console.log(`[Auth Navigator] User Found: ${user.uid}`);
        dispatch(setCurrentUserUID(user.uid));
        trigger(null);
        if (!isLoading && currentUser) {
          dispatch(login(currentUser));
        }
      }
    });

    return unsubscribe;
  }, [auth]);

  // If User Exists -> Return Protected Path
  if (auth.currentUser && currentUser) {
    return children;
  } else {
    return null;
  }
}

export function AuthNavigator() {
  return (
    <Routes>
      <Route path="/" element={<Root />} />
      <Route path="/invite/:username" element={<Root />} />

      {/* Authenticated Routes */}
      <Route
        path="/home"
        element={
          <RequireAuth>
            <Home />
          </RequireAuth>
        }
      />

      {/* 404 Route */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default AuthNavigator;
